<script setup lang="ts">
interface IProps {
    retainBoxInMobile?: boolean;
    showHeaderInMobile?: boolean;
    disableBoxStyle?: boolean;
    disableTitlePortal?: boolean;
    title?: string;
    mobileOnly?: boolean;
}
const {
    disableTitlePortal,
    mobileOnly,
    disableBoxStyle,
    showHeaderInMobile,
    title = '',
    retainBoxInMobile,
} = defineProps<IProps>();
const { isMobile } = useSize();
</script>
<template>
    <div
        class="panel-container"
        :class="{
            'retain-box-in-mobile': retainBoxInMobile,
            box: !disableBoxStyle,
        }"
    >
        <ClientOnly>
            <Teleport v-if="isMobile && !disableTitlePortal" to="#portal-title">
                <div>
                    {{ title }}
                </div>
            </Teleport>
        </ClientOnly>
        <div
            v-if="!mobileOnly && title"
            class="header"
            :class="{ 'show-header-in-mobile': showHeaderInMobile }"
        >
            <h1 class="title">{{ title }}</h1>
            <slot name="header" />
        </div>
        <hr v-if="!mobileOnly && title" class="split-line" />
        <slot />
    </div>
</template>

<style scoped lang="scss">
.panel-container {
    display: inline-block;
    border-radius: 12px;
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;

    &.box {
        @include shadow();
        background-color: white;
    }
    @include mobile-only {
        padding: 16px;
        margin-bottom: 12px;
    }
    &:not(.retain-box-in-mobile) {
        @include mobile-only {
            margin-right: 0;
            margin-bottom: 8px;
            background: none;
            padding: 0;
            @include shadow(0);
        }
    }
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:not(.show-header-in-mobile) {
            @include mobile-only {
                display: none;
            }
        }
        .title {
            margin-block: 0;
            @include tg-display4($w7);
            @include mobile-only {
                @include tg-xl($w7);
                margin-bottom: 16px;
            }
        }
    }
    .split-line {
        border: 1px solid usePalette($p-cool-gray, $p-100);
        margin-block: 24px;
        @include mobile-only {
            display: none;
        }
    }
}
</style>
